module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/arrow-up-green.43eb9f50.svg";